__turbopack_context__.v({
  "addButton": "client-dossier-visual-module__dRKQ3G__addButton",
  "addButtonPressed": "client-dossier-visual-module__dRKQ3G__addButtonPressed",
  "button": "client-dossier-visual-module__dRKQ3G__button",
  "buttonDone": "client-dossier-visual-module__dRKQ3G__buttonDone",
  "clientRow": "client-dossier-visual-module__dRKQ3G__clientRow",
  "dropdown": "client-dossier-visual-module__dRKQ3G__dropdown",
  "dropdownRow": "client-dossier-visual-module__dRKQ3G__dropdownRow",
  "dropdownRowActive": "client-dossier-visual-module__dRKQ3G__dropdownRowActive",
  "dropdownVisible": "client-dossier-visual-module__dRKQ3G__dropdownVisible",
  "fieldPair": "client-dossier-visual-module__dRKQ3G__fieldPair",
  "hideNarrow": "client-dossier-visual-module__dRKQ3G__hideNarrow",
  "kvkPill": "client-dossier-visual-module__dRKQ3G__kvkPill",
  "kvkPillVisible": "client-dossier-visual-module__dRKQ3G__kvkPillVisible",
  "modal": "client-dossier-visual-module__dRKQ3G__modal",
  "newRow": "client-dossier-visual-module__dRKQ3G__newRow",
  "newRowIn": "client-dossier-visual-module__dRKQ3G__newRowIn",
  "newRowMarked": "client-dossier-visual-module__dRKQ3G__newRowMarked",
  "root": "client-dossier-visual-module__dRKQ3G__root",
  "scrim": "client-dossier-visual-module__dRKQ3G__scrim",
  "scrimVisible": "client-dossier-visual-module__dRKQ3G__scrimVisible",
});
